import React from 'react';
import PropTypes from 'prop-types';
import YoutubePlayer from 'modules/common/YoutubePlayer';
import VideoOverlay from 'modules/videotutorials/components/VideoTutorial/VideoOverlay';
import {compose, renameProp, withStateHandlers} from 'recompose';
import screenfull from 'screenfull';

const VideoWrapper = ({
  autoplay,
  className = '',
  closeVideoOverlay,
  handleVideoPlaying,
  handleVideoEnded,
  nextStepProps,
  isScoreVisible,
  isVideoOverlayVisible,
  videoId,
  trackSlug,
}) => (
  <div className={`relative ${className}`}>
    <YoutubePlayer
      key={videoId}
      autoplay={autoplay}
      onVideoPlaying={handleVideoPlaying}
      onVideoEnded={handleVideoEnded}
      videoId={videoId}
    />
    {isVideoOverlayVisible && (
      <VideoOverlay
        {...nextStepProps}
        isScoreVisible={isScoreVisible}
        closeVideoOverlay={closeVideoOverlay}
        trackSlug={trackSlug}
      />
    )}
  </div>
);

VideoWrapper.propTypes = {
  autoplay: PropTypes.bool.isRequired,
  className: PropTypes.string,
  closeVideoOverlay: PropTypes.func.isRequired,
  handleVideoPlaying: PropTypes.func.isRequired,
  handleVideoEnded: PropTypes.func.isRequired,
  nextStepProps: PropTypes.object.isRequired,
  stepProgress: PropTypes.string.isRequired, // eslint-disable-line
  isScoreVisible: PropTypes.bool.isRequired,
  isVideoOverlayVisible: PropTypes.bool.isRequired,
  videoId: PropTypes.string.isRequired,
  trackSlug: PropTypes.string.isRequired,
};

const enhance = compose(
  withStateHandlers(
    {
      isScoreVisible: false,
      isVideoOverlayVisible: false,
    },
    {
      closeVideoOverlay: () => () => ({
        isVideoOverlayVisible: false,
      }),
      handleVideoEnded: (state, {stepProgress, updateProgress}) => () => {
        //  we determine if we show the Score before updating it
        const isScoreVisible = stepProgress !== 'completed';
        updateProgress(true);
        if (screenfull.element) {
          screenfull.exit();
        }
        return {
          isScoreVisible,
          isVideoOverlayVisible: true,
        };
      },
    },
  ),
  renameProp('updateProgress', 'handleVideoPlaying'),
);

export default enhance(VideoWrapper);
